import Ajv, { JTDSchemaType } from "ajv/dist/jtd.js";
const ajv = new Ajv();

export namespace Systems {
  //Type
  export type GetSystems = {
    ids: SystemId[];
  };
  export type SystemId = {
    system: string;
    supplierId: string;
    uid: string;
  };
  //Schema
  const schema: JTDSchemaType<GetSystems> = {
    properties: {
      ids: {
        elements: {
          properties: {
            supplierId: {
              type: "string",
            },
            system: {
              type: "string",
            },
            uid: { type: "string" },
          },
        },
      },
    },
  };
  //Validate Function
  export const validate = ajv.compile(schema);
}

export namespace Suppliers {
  //type
  export type GetSuppliers = Supplier[];
  export type Supplier = {
    SupplierId: string;
    Name: string;
    System?: string;
  };
  //schema
  const schema: JTDSchemaType<GetSuppliers> = {
    elements: {
      properties: {
        Name: {
          type: "string",
        },
        SupplierId: { type: "string" },
      },
      optionalProperties: {
        System: { type: "string" },
      },
    },
  };
  //Validate Function
  export const validate = ajv.compile(schema);
}

export namespace PrintItems {
  export type PrintItem = {
    Quantity: string;
    Final: boolean | null;
    MaterialId: string;
    MaterialDescription: string;
    Supplier: string;
    Layout: string;
    LayoutSize: string | null;
    PrintData: string | null;
    Released: boolean;
  };

  export type GetPrintItems = PrintItem[];
  //schema
  const schema: JTDSchemaType<GetPrintItems> = {
    elements: {
      additionalProperties: true,
      properties: {
        Final: { type: "boolean", nullable: true },
        Layout: {
          type: "string",
        },
        LayoutSize: { type: "string", nullable: true },
        MaterialDescription: { type: "string" },
        MaterialId: { type: "string" },
        PrintData: { type: "string", nullable: true },
        Quantity: { type: "string" },
        Supplier: { type: "string" },
        Released: { type: "boolean" },
      },
    },
  };
  //Validate Function
  export const validate = ajv.compile(schema);

  export type PrintItemPdf = {
    Date: string;
    PrintItemId: string;
    Quantity: string;
    Final: boolean | null;
    MaterialId: string;
    MaterialDescription: string;
    Supplier: string;
    Layout: string;
    LayoutSize: string | null;
    PrintData: string | null;
    Released: boolean | null;
  };

  export type GetPrintItemsPdf = PrintItemPdf[];
  //schema
  const schemaPdf: JTDSchemaType<GetPrintItemsPdf> = {
    elements: {
      additionalProperties: true,
      properties: {
        Date: { type: "string" },
        PrintItemId: { type: "string" },
        Final: { type: "boolean", nullable: true },
        Layout: {
          type: "string",
        },
        LayoutSize: { type: "string", nullable: true },
        MaterialDescription: { type: "string" },
        MaterialId: { type: "string" },
        PrintData: { type: "string", nullable: true },
        Quantity: { type: "string" },
        Supplier: { type: "string" },
        Released: { type: "boolean", nullable: true },
      },
    },
  };
  //Validate Function
  export const validatePdf = ajv.compile(schemaPdf);
}

export namespace Serials {
  export type GetSerials = {
    serialset: SerialSet[];
    limit?: boolean;
  };
  export type SerialSet = {
    Serialnumber: string;
    MaterialId: string;
    Plant: string;
    Supplier: string | null;
    Order: string;
    Timestamp: string;
    Type?: string;
  };
  //schema
  const schema: JTDSchemaType<GetSerials> = {
    properties: {
      serialset: {
        elements: {
          properties: {
            MaterialId: { type: "string" },
            Order: { type: "string" },
            Plant: { type: "string" },
            Serialnumber: { type: "string" },
            Supplier: { type: "string", nullable: true },
            Timestamp: { type: "string" },
          },
          optionalProperties: { Type: { type: "string" } },
        },
      },
    },
    optionalProperties: {
      limit: { type: "boolean" },
    },
  };
  //Validate Function
  export const validate = ajv.compile(schema);
}
